const audit = {
    title: 'アクティビティ監査',
    period: '期間',
    totalEvents: '総イベント数',
    activeUsers: 'アクティブユーザー',
    totalAnomalies: '不審行為(累計)',
    unresolvedAnomalies: '未解決の不審行為',
    eventsByCategory: 'カテゴリ別イベント',
    recentEvents: '最近のイベント',
    categoryAll: 'カテゴリ: すべて',
    time: '時刻',
    action: 'アクション',
    result: '結果',
    category: 'カテゴリー',
    user: 'ユーザー',
    resource: 'リソース',
    durationMs: '所要時間 (ms)',
    noMatchingEvents: '該当するイベントがありません',
    summaryFetchFailed: 'サマリ取得に失敗: {{message}}',
    eventsFetchFailed: 'イベント取得に失敗: {{message}}',
    csvExportFailed: 'CSVエクスポート失敗: {{message}}',
    results: {
      all: 'すべて',
      success: 'success',
      failure: 'failure',
      error: 'error',
    },
  };

export default audit;
